var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 35,
    viewBox: "0 0 49 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.738 24.286 2.495 31.51A1.457 1.457 0 0 0 3.524 34h42.222a1.457 1.457 0 0 0 1.087-2.427l-6.503-7.287",
    stroke: "#1C1A37",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#1C1A37",
    strokeWidth: 0.971,
    x: 8.074,
    y: 0.486,
    width: 34.152,
    height: 24.043,
    rx: 3.886
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.862 6.881)",
    fill: "#E5A033"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.288,
    cy: 2.833,
    rx: 2.858,
    ry: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.123 6.375h4.33c1.172 0 2.122.95 2.122 2.123v2.835H0V8.498c0-1.173.95-2.123 2.123-2.123z"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#1C1A37",
    strokeWidth: 0.5,
    x: 10.26,
    y: 2.921,
    width: 29.779,
    height: 18.929,
    rx: 1.943
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#E5A033",
    x: 15.097,
    y: 29.871,
    width: 19.863,
    height: 1.457,
    rx: 0.729
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLaptop);
export default __webpack_public_path__ + "static/media/ic_laptop.7c118e92272c80bf8d899a3ab01288ca.svg";
export { ForwardRef as ReactComponent };